/**
 * @description 基本格式
 *
 * @props {Boolean} headFixed 头部固定，"base-content"滚动
 *
 */
<template>
   <div class="base-main"
        id="gj-base-main"
        :class="{'base-main--border': border, 'head-fixed': headFixed, 'base-main-margin':hasMagin}"
        :style="{padding: noPadding ? 0 : '', ...baseStyle}">
     <div class="base-main_margin" :style="{marginBottom: ($slots['filter-group'] && !$slots['tool-group'] && !$slots['operate-group']) ? '12px' : '0'}">
       <slot name="filter-group"></slot>
     </div>
     <el-row
         v-if="$slots['operate-group'] || $slots['tool-group']"
         type="flex"
         justify="space-between"
         align="middle">
       <div class="operate-group" v-gutter="12">
         <slot name="operate-group"></slot>
       </div>
       <div class="tool-group">
         <slot name="tool-group"></slot>
       </div>
     </el-row>
     <div v-if="$slots.chart"
          :class="[
            'chart'
          ]">
       <slot name="chart"></slot>
     </div>
     <div :class="[
        'table', tableShadow ? 'table-shadow' : '',
        tableBorderTop ? 'table-border-top' : '',
        tableBorder ? 'table-border' : '',
        parentTable ? 'parent-table' : '',
     ]">
       <slot name="table"></slot>
     </div>
     <div v-if="$slots['base-content']" class="base-content" :style="contentStyle">
       <slot name="base-content"></slot>
     </div>
   </div>
</template>

<script>
  export default {
    name: "app-base-main",
    props: {
      hasMagin: {
        type: Boolean,
        default: true
      },
      tableShadow: {
        type: Boolean,
        default: false
      },
      tableBorder: {
        type: Boolean,
        default: false
      },
      tableBorderTop: {
        type: Boolean,
        default: false
      },
      noPadding: {
        type: Boolean,
        default: false
      },
      border: {
        type: Boolean,
        default: false
      },
      headFixed: {
        type: Boolean,
        default: false
      },
      // base-main扩展样式
      baseStyle: {
        type: Object,
        default: ()=> ({})
      },
      // base-content扩展样式
      contentStyle: {
        type: Object,
        default: ()=> ({})
      },
      parentTable: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/app";
  @import '@/assets/styles/index';
  .base-main-margin{
    // margin: $app-module-padding;
    padding: $app-module-padding;
  }
  .base-main {
    padding: 16px;
    background: #fff;
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
    &.head-fixed {
      height: 100%;
      padding: 16px 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      .base-content {
        flex: 1;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 0 20px;
      }
    }
  }
  .base-main--border {
    border: 1px solid #EBEEF5;
    border-radius: 4px;
  }
  .filter-group {

  }
  .operate-group {
    margin: 12px 0 12px;
  }
  .tool-group {
    display: flex;
    align-items: center;
  }
  .table {
    
  }
  .parent-table{
    flex: 1;
    overflow: auto;
    box-sizing: border-box;
  }
  .chart {
    margin-bottom: 10px;
  }
  .table-shadow {
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.15);
  }
  .table-border-top {
    // border-top: 1px solid #EBEEF5;
  }
  .table-border {
    border: 1px solid #D8DADD;
  }
</style>
